import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CetateanComponent } from './cetatean.component';
import { RequestsComponent } from './requests/requests.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { RequestDetailsComponent } from './requests/request-details/request-details.component';
import { AddRequestComponent } from './requests/add-request/add-request.component';
import { SubsemnatulModule } from 'src/app/shared/subsemnatul/subsemnatul.module';
import { RequestHistoryComponent } from './requests/request-history/request-history.component';
import { CetateanAccountsModule } from './cetatean-accounts/cetatean-accounts.module';
import { BeneficiariModule } from './beneficiari/beneficiari.module';
import { PreEnrolledAccountsModule } from './pre-enrolled-accounts/pre-enrolled-accounts.module';
import { UpdateRequestStatusComponent } from './requests/update-request-status/update-request-status.component';
import { AssignRequestComponent } from './requests/assign-request/assign-request.component';
import { ActiuniCerereCardModule } from 'src/app/shared/actiuni-cerere-card/actiuni-cerere-card.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CereriIstoricComponent } from './requests/request-details/cereri-istoric/cereri-istoric.component';
import { ActualizareCerereComponent } from './requests/request-details/actualizare-cerere/actualizare-cerere.component';
import { CerereDetaliiSabloaneComponent } from './requests/request-details/sabloane/cerere-detalii-sabloane.component';
import { PipesModule } from 'src/app/utils/pipes/pipes.module';
import { RecenziiModule } from './recenzii/recenzii.module';
import { DocumenteCetateanModule } from './documente-cetatean/documente-cetatean.module';
import { ConfirmareDocumenteModule } from './confirmare-documente/confirmare-documente.module';
import { BorderouModule } from './borderou/borderou.module';
import { RapoarteModule } from './rapoarte/rapoarte.module';

@NgModule({
    declarations: [
        CetateanComponent,
        RequestsComponent,
        RequestDetailsComponent,
        AddRequestComponent,
        RequestHistoryComponent,
        UpdateRequestStatusComponent,
        AssignRequestComponent,
        CereriIstoricComponent,
        ActualizareCerereComponent,
        CerereDetaliiSabloaneComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        SubsemnatulModule,
        CetateanAccountsModule,
        BeneficiariModule,
        PreEnrolledAccountsModule,
        ActiuniCerereCardModule,
        BrowserAnimationsModule,
        PipesModule,
        RecenziiModule,
        DocumenteCetateanModule,
        ConfirmareDocumenteModule,
        BorderouModule,
        RapoarteModule
    ],
    exports: [CetateanComponent, RequestsComponent],
})
export class CetateanModule { }
